export default "data:image/webp;base64,UklGRiQAAABXRUJQVlA4TBgAAAAvJ4AGAIVYMOHJHzCFnUM8EP3PZh7mZgY="